<mat-autocomplete autoActiveFirstOption>
  @for (user of data; track trackById($index, user)) {
    <mat-option (onSelectionChange)="emitSelect($event, user)" [value]="user">
      <div class="user-option">
        <span class="user-option-name">
          {{ user.fullName }}
        </span>
        <span class="user-option-email">
          {{ user.email }}
        </span>
      </div>
    </mat-option>
  }
</mat-autocomplete>
